import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { Card } from "../components/ui/card";

export default function PaymentMethods() {
  const [methods, setMethods] = useState([]);
  const [name, setName] = useState("");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchMethods = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/payment_methods`, { withCredentials: true });
      setMethods(data);
    } catch (e) {
      toast.error("Ödeme yöntemleri alınamadı.");
    }
  }, [BACKEND_URL]);

  useEffect(() => {
    fetchMethods();
  }, [fetchMethods]);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await axios.post(`${BACKEND_URL}/api/payment_methods`, { name }, { withCredentials: true });
      toast.success("Ödeme yöntemi oluşturuldu.");
      setName("");
      fetchMethods();
    } catch (e) {
      toast.error("Oluşturulamadı.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/payment_methods/${id}`, { withCredentials: true });
      toast.success("Ödeme yöntemi silindi.");
      fetchMethods();
    } catch (e) {
      toast.error("Silinemedi.");
    }
  };

  return (
    <div className="space-y-8 max-w-4xl">
      <div className="flex items-center justify-between border-b border-border pb-4">
        <h1 className="text-3xl font-heading font-bold">Ödeme Yöntemleri</h1>
      </div>

      <Card className="swiss-card p-6">
        <form onSubmit={handleCreate} className="flex gap-4 items-end">
          <div className="flex-1 space-y-2">
            <Label htmlFor="method-name">Yeni Ödeme Yöntemi Adı</Label>
            <Input
              id="method-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Örn: Nakit, Kredi Kartı, Havale/EFT"
              data-testid="method-name-input"
            />
          </div>
          <Button type="submit" data-testid="create-method-button">
            <Plus size={16} className="mr-2" /> Ekle
          </Button>
        </form>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {methods.map(method => (
          <Card key={method.id} className="swiss-card flex items-center justify-between p-4">
            <span className="font-medium" data-testid={`method-name-${method.id}`}>{method.name}</span>
            <Button
              variant="ghost"
              size="icon"
              className="text-destructive hover:bg-destructive/10"
              onClick={() => {
                toast("Emin misiniz?", {
                  action: {
                    label: "Evet, Sil",
                    onClick: () => handleDelete(method.id)
                  }
                });
              }}
              data-testid={`delete-method-button-${method.id}`}
            >
              <Trash2 size={18} />
            </Button>
          </Card>
        ))}
        {methods.length === 0 && (
          <div className="text-muted-foreground text-sm col-span-full">Kayıtlı ödeme yöntemi bulunamadı.</div>
        )}
      </div>
    </div>
  );
}
